export const getActiveChangeWarningKey = (initialActive: boolean, active: boolean): string | null => {
	if (initialActive === active) {
		return null;
	}

	return active
		? "administration.organizations.warnings.activate-users"
		: "administration.organizations.warnings.deactivate-users";
};
